import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { urls } from 'src/app/utils/url-utils';
import { errorHandl } from 'src/app/utils/network-utils';

/**
 * Business Reports API client — same endpoints as the business-reports-ui
 * React app (/api/business-reports/*), served from urls.BASE_URL
 * (environment.baseUrl + 'api/'). startDate/endDate are already full ISO
 * strings (toISOString()) by the time they reach this service.
 */
@Injectable({
  providedIn: 'root'
})
export class BusinessReportsService {

  /** Keeps the selected date range in sync as the user navigates between Reports Pro tabs (each is its own route/component instance). */
  savedRange: { startDate: string; endDate: string } | null = null;

  constructor(private http: HttpClient) { }

  private dateRangeParams(startDate: string, endDate: string): HttpParams {
    return new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate);
  }

  private getReport(endpoint: string, startDate: string, endDate: string): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + endpoint, { params: this.dateRangeParams(startDate, endDate) })
      .pipe(catchError(errorHandl));
  }

  fetchOverview(startDate: string, endDate: string): Observable<any> {
    return this.getReport(urls.BUSINESS_REPORTS_OVERVIEW_URL, startDate, endDate);
  }

  fetchBreakdown(startDate: string, endDate: string): Observable<any> {
    return this.getReport(urls.BUSINESS_REPORTS_BREAKDOWN_URL, startDate, endDate);
  }

  fetchDriverDigest(startDate: string, endDate: string): Observable<any> {
    return this.getReport(urls.BUSINESS_REPORTS_DRIVER_DIGEST_URL, startDate, endDate);
  }

  fetchTrips(startDate: string, endDate: string): Observable<any> {
    return this.getReport(urls.BUSINESS_REPORTS_TRIPS_URL, startDate, endDate);
  }

  fetchRevenue(startDate: string, endDate: string): Observable<any> {
    return this.getReport(urls.BUSINESS_REPORTS_REVENUE_URL, startDate, endDate);
  }

  fetchTimeliness(startDate: string, endDate: string, scoringMode: 'merged' | 'pickup' | 'dropoff' = 'merged'): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.BUSINESS_REPORTS_TIMELINESS_URL, {
      startDate,
      endDate,
      scoringMode
    }).pipe(catchError(errorHandl));
  }
}
